import { runWithQoS, Feature } from '../../../shared';
import ContactsAPIClient, { PersonaInfo } from 'owa-contacts-api';

export function getListContacts(): Promise<PersonaInfo[]> {
    return runWithQoS<PersonaInfo[]>({
        scenarioName: 'GetListContacts',
        feature: Feature.ContactManagement,
        operation: ContactsAPIClient.ListContacts(),
    });
}
